export const notEmpty = a => Array.isArray(a) && a.length !== 0;
